import { UserDocument } from '@/entities/user-document';
import { http } from '@/http';

const ITEMS_PER_PAGE = 25;
export type LastEvaluatedKey = {
	PK: string;
	SK: string;
};

export const getUserDocuments = async (
	lastEvaluatedKeySK: LastEvaluatedKey | null = null,
	status: 'Pending' | 'Signed', //TODO include this filter in the request (pending backend)
) => {
	const getUserDocumentsResponse = await http.get<{
		items: UserDocument[];
		last_evaluated_key: { PK: string; SK: string };
	}>(
		`/user/documents?items_per_page=${ITEMS_PER_PAGE}${lastEvaluatedKeySK ? '&last_evaluated_key=' + encodeURIComponent(JSON.stringify(lastEvaluatedKeySK)) : ''}&State=${status}`,
	);
	if (getUserDocumentsResponse) {
		return getUserDocumentsResponse;
	}
};
